import isString from 'lodash/isString';

export const isTrueOrStringTrue = (val) => {
  return val === true || (isString(val) && val.toLowerCase() === 'true');
};

export const isFalseOrStringFalse = (val) => {
  return val === false || (isString(val) && val.toLowerCase() === 'false');
};
